const MEDIA_ITEMS = [
  {
    id: 1,
    title: '娱乐圈最新爆料汇总：顶流明星私生活大起底',
    tag: '娱乐圈',
    time: '2小时前',
    views: '12.8万',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%2C%20warm%20lighting%2C%20abstract%20entertainment%20news%20theme%2C%20soft%20coral%20and%20cream%20tones%2C%20clean%20minimalist%20studio%20background%2C%20suggesting%20celebrity%20gossip%20and%20entertainment%20news%2C%20magazine%20editorial%20quality%2C%20no%20text%20visible%2C%20professional%20photography%2C%20warm%20ambient%20light&width=600&height=400&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '网红圈大地震！多位知名博主深陷争议风波',
    tag: '网红圈',
    time: '5小时前',
    views: '9.6万',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%2C%20warm%20amber%20lighting%2C%20abstract%20social%20media%20trending%20theme%2C%20clean%20minimalist%20background%20with%20warm%20gradient%2C%20suggesting%20internet%20celebrity%20drama%2C%20magazine%20quality%2C%20soft%20shadows%2C%20professional%20composition%2C%20no%20text%2C%20harmonious%20warm%20tones&width=600&height=400&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺节目录制现场突发状况，节目组紧急回应',
    tag: '综艺',
    time: '8小时前',
    views: '7.3万',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%2C%20warm%20lighting%2C%20abstract%20television%20studio%20production%20theme%2C%20clean%20minimalist%20background%20with%20soft%20coral%20accents%2C%20suggesting%20variety%20show%20production%2C%20magazine%20editorial%20quality%2C%20professional%20photography%2C%20warm%20ambient%20atmosphere%2C%20no%20text%20visible&width=600&height=400&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
              热门爆料
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新吃瓜速递
            </h2>
          </div>
          <a
            href="#updates"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-background-300/80 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 backdrop-blur-sm flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {item.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}